import { useState } from 'react'
import { Card, CardHeader, CardBody, Button, Label, Input, FormFeedback, Alert, Spinner } from 'reactstrap'
import useForm from '../CustomHooks/FormHook'
import { CREATE_DATABASE_USER_MUTATION } from '../../graphql'
import { handleGraphQLErrors } from '../../utils.js'
import { gql } from '@apollo/client'
import { FaArrowLeft } from 'react-icons/fa'

const CREATE_DATABASE_USER = gql(CREATE_DATABASE_USER_MUTATION)

export default function CreateDatabaseUser() {
  console.log('CreateDatabaseUser rendered')

  const { inputs, handleInputChange, resetInputs } = useForm({ userName: '' }, handleSubmit)
  const [userNameState, setUserNameState] = useState({ state: '', message: '' })
  const [spinner, setSpinner] = useState(false)
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [userCreated, setUserCreated] = useState(false)

  function startOver() {
    resetInputs({ userName: '' })
    setUserCreated(false)
  }

  async function handleSubmit() {
    console.log('CreateDatabaseUser.handleSubmit: ', inputs.userName)
    if (!inputs.userName) {
      setGraphQLErrors([])
      setUserNameState({ state: 'has-danger', message: 'User Name is required.' })
    } else {
      setUserNameState({ state: '', message: '' })
      setSpinner(true)
      try {
        const variables = { user: inputs.userName, password: inputs.userName }
        const { data, errors } = await window.apolloClient.mutate({ mutation: CREATE_DATABASE_USER, variables: variables })
        if (data.createDatabaseUser === 'SUCCESS!') {
          setGraphQLErrors([])
          setUserCreated(true)
        } 
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setSpinner(false)
      }
    }
  }

  let button =  <Button color="primary" onClick={handleSubmit}>Create Database User</Button>
  if (spinner) {
    button = <Button disabled color="primary"><Spinner size="sm" /> Creating database user...</Button>
  }

  let cardBody = 
    <CardBody>
      <Alert color="danger" isOpen={graphQLErrors.length ? true : false}>{graphQLErrors.length ? graphQLErrors[0].message : ''}</Alert>
      <Label for="userName">User Name</Label>
      <Input
        id="userName"
        name="userName"
        invalid={userNameState.state === 'has-danger'}
        valid={userNameState.state === 'has-success'}
        onChange={handleInputChange}
      />
      <FormFeedback>{userNameState.message}</FormFeedback>
      <div style={{ paddingTop: '10px', textAlign: 'center' }}>
        {button}
      </div>
    </CardBody>

  if (userCreated) {
    cardBody = 
      <CardBody>
        <Alert color="success">{`User ${inputs.userName.toUpperCase()} was created successfully!`}</Alert>
        <div style={{ textAlign: 'center' }}>
          <Button style={{ float: 'left' }} onClick={startOver}><FaArrowLeft /> Start Over</Button>
        </div>
      </CardBody>
  }

  return (
    <Card style={{ maxWidth: '500px', marginTop: '20px' }}>
      <CardHeader style={{ fontWeight: 'bold' }}>Create Database User</CardHeader>
      {cardBody}
    </Card>
  )
}
